export default __webpack_public_path__ + "8a57326a6bbc4b4f2ff7a3a3252aa9a3.png";